/**
 * DYMO Connect label for a visitor badge on stock 30857.
 *
 * The label bounds and NameBadgeCard 30857 name are copied from the template
 * that printed on the LabelWriter 550. Each visible field is its own text
 * object. The layout stays fixed; only the text changes per visit.
 */

const LABEL_WIDTH = 3.706667;
const LABEL_HEIGHT = 2.216667;

export const VISITOR_BADGE_PHOTO = {
  name: 'PHOTO',
  x: 0.26,
  y: 0.36,
  width: 1.08,
  height: 1.22,
};

export const VISITOR_BADGE_OBJECTS = [
  { name: 'SCHOOL', x: 0.26, y: 0.1, width: 2.2, height: 0.22, fontSize: 12, bold: true, align: 'Left' },
  { name: 'CARPOOL', x: 2.5, y: 0.1, width: 1.28, height: 0.22, fontSize: 12, bold: true, align: 'Right' },
  { name: 'VISITOR_TYPE', x: 1.44, y: 0.32, width: 2.34, height: 0.4, fontSize: 32, bold: true, align: 'Left' },
  { name: 'FULL_NAME', x: 1.44, y: 0.72, width: 2.34, height: 0.3, fontSize: 20, bold: true, align: 'Left' },
  { name: 'DESTINATION', x: 1.44, y: 1.06, width: 2.34, height: 0.18, fontSize: 12, bold: false, align: 'Left' },
  { name: 'VISIT_REASON', x: 1.44, y: 1.24, width: 2.34, height: 0.18, fontSize: 12, bold: false, align: 'Left' },
  { name: 'CHECK_IN', x: 0.26, y: 1.66, width: 3.52, height: 0.2, fontSize: 12, bold: true, align: 'Center' },
  { name: 'BADGE_NUMBER', x: 0.26, y: 1.88, width: 3.52, height: 0.18, fontSize: 10, bold: false, align: 'Center' },
];

function imageObject(object) {
  return `        <ImageObject>
          <Name>${object.name}</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="1" G="1" B="1"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="1" G="1" B="1"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <BorderStyle>SolidLine</BorderStyle>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <Data></Data>
          <ScaleMode>Uniform</ScaleMode>
          <HorizontalAlignment>Center</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <ObjectLayout>
            <DYMOPoint>
              <X>${object.x}</X>
              <Y>${object.y}</Y>
            </DYMOPoint>
            <Size>
              <Width>${object.width}</Width>
              <Height>${object.height}</Height>
            </Size>
          </ObjectLayout>
        </ImageObject>`;
}

function textObject(object) {
  const bold = object.bold ? 'True' : 'False';
  return `        <TextObject>
          <Name>${object.name}</Name>
          <Brushes>
            <BackgroundBrush>
              <SolidColorBrush>
                <Color A="0" R="1" G="1" B="1"></Color>
              </SolidColorBrush>
            </BackgroundBrush>
            <BorderBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </BorderBrush>
            <StrokeBrush>
              <SolidColorBrush>
                <Color A="1" R="0" G="0" B="0"></Color>
              </SolidColorBrush>
            </StrokeBrush>
            <FillBrush>
              <SolidColorBrush>
                <Color A="0" R="1" G="1" B="1"></Color>
              </SolidColorBrush>
            </FillBrush>
          </Brushes>
          <Rotation>Rotation0</Rotation>
          <OutlineThickness>1</OutlineThickness>
          <IsOutlined>False</IsOutlined>
          <Margin>
            <DYMOThickness Left="0" Top="0" Right="0" Bottom="0" />
          </Margin>
          <HorizontalAlignment>${object.align}</HorizontalAlignment>
          <VerticalAlignment>Middle</VerticalAlignment>
          <FitMode>AlwaysFit</FitMode>
          <IsVertical>False</IsVertical>
          <FormattedText>
            <FitMode>AlwaysFit</FitMode>
            <HorizontalAlignment>${object.align}</HorizontalAlignment>
            <VerticalAlignment>Middle</VerticalAlignment>
            <IsVertical>False</IsVertical>
            <LineTextSpan>
              <TextSpan>
                <Text>${object.name}</Text>
                <FontInfo>
                  <FontName>Arial</FontName>
                  <FontSize>${object.fontSize}</FontSize>
                  <IsBold>${bold}</IsBold>
                  <IsItalic>False</IsItalic>
                  <IsUnderline>False</IsUnderline>
                  <FontBrush>
                    <SolidColorBrush>
                      <Color A="1" R="0" G="0" B="0"></Color>
                    </SolidColorBrush>
                  </FontBrush>
                </FontInfo>
              </TextSpan>
            </LineTextSpan>
          </FormattedText>
          <ObjectLayout>
            <DYMOPoint>
              <X>${object.x}</X>
              <Y>${object.y}</Y>
            </DYMOPoint>
            <Size>
              <Width>${object.width}</Width>
              <Height>${object.height}</Height>
            </Size>
          </ObjectLayout>
        </TextObject>`;
}

export function buildVisitorBadgeLabelXml() {
  return `<?xml version="1.0" encoding="utf-8"?>
<LabelFile version="1">
  <LabelApplication>Blank</LabelApplication>
  <DYMOLabel>
    <Description>DYMO Label</Description>
    <Orientation>Landscape</Orientation>
    <LabelName>NameBadgeCard 30857</LabelName>
    <InitialLength>0</InitialLength>
    <BorderStyle>SolidLine</BorderStyle>
    <DYMORect>
      <DYMOPoint>
        <X>0.2333333</X>
        <Y>0.05666666</Y>
      </DYMOPoint>
      <Size>
        <Width>${LABEL_WIDTH}</Width>
        <Height>${LABEL_HEIGHT}</Height>
      </Size>
    </DYMORect>
    <BorderColor>
      <SolidColorBrush>
        <Color A="1" R="0" G="0" B="0"></Color>
      </SolidColorBrush>
    </BorderColor>
    <BorderThickness>1</BorderThickness>
    <Show_Border>False</Show_Border>
    <DynamicLayoutManager>
      <RotationBehavior>ClearObjects</RotationBehavior>
      <LabelObjects>
${imageObject(VISITOR_BADGE_PHOTO)}
${VISITOR_BADGE_OBJECTS.map(textObject).join('\n')}
      </LabelObjects>
    </DynamicLayoutManager>
  </DYMOLabel>
</LabelFile>`;
}

export const VISITOR_BADGE_LABEL_XML = buildVisitorBadgeLabelXml();

function labeledLine(label, value) {
  const text = String(value || '').trim();
  return text ? `${label}: ${text}` : '';
}

export function badgeTextFields(badge = {}) {
  const checkIn = [
    badge.dateLabel,
    badge.timeLabel ? `Check-in ${badge.timeLabel}` : '',
  ].filter(Boolean).join(' • ');
  const badgeNumber = String(badge.badgeNumber || '').trim();
  return {
    SCHOOL: badge.schoolName || '',
    CARPOOL: badge.productName || 'Car-Pool',
    VISITOR_TYPE: badge.visitorTypeLabel || '',
    FULL_NAME: badge.fullName || '',
    DESTINATION: labeledLine('Visiting', badge.destination),
    VISIT_REASON: labeledLine('Purpose', badge.visitReasonLabel),
    CHECK_IN: checkIn,
    BADGE_NUMBER: badgeNumber ? `Badge #${badgeNumber} • Valid today only` : '',
  };
}
